import { isAfter, isBefore, isEqual } from "date-fns"
import { IsValidCheck } from "./types"
import { sanitiseReg } from "../../utils"

export const isNotCoverDateMovedForwardError = `It looks like this vehicle is already on your policy. Please recheck and try again. If you need edit your cover dates, please use the edit cover date feature.`
export const isNotCoverDateMovedForward: IsValidCheck = (entry, currentEntries) => {
  if (!entry.onCoverDate || !entry.registrationNumber) return undefined
  const onCoverDate = new Date(entry.onCoverDate as string)
  const currentEntry = currentEntries?.find((it) => it.uniqueRef === entry.uniqueRef)
  if (!!currentEntry && isEqual(onCoverDate, new Date(currentEntry!.onCoverDate))) return undefined
  const now = new Date()
  const currentEntriesWithMatchingVRNAndOnCoverDateInPast = (currentEntries || [])
    .map((v) => ({
      registrationNumber: v.registrationNumber,
      onCoverDate: new Date(v.onCoverDate),
      offCoverDate: v.offCoverDate ? new Date(v.offCoverDate) : v.offCoverDate,
    }))
    .filter(
      (v) =>
        sanitiseReg(v.registrationNumber) === sanitiseReg(entry.registrationNumber as string) &&
        isBefore(v.onCoverDate, now)
    )
  const currentEntriesWithLowerOnCoverDates = currentEntriesWithMatchingVRNAndOnCoverDateInPast.some(
    (v) => isBefore(v.onCoverDate, onCoverDate) && (!v.offCoverDate || isAfter(v.offCoverDate as Date, onCoverDate))
  )

  return !(currentEntriesWithMatchingVRNAndOnCoverDateInPast.length && currentEntriesWithLowerOnCoverDates)
}
